<template>
  <div class="approval-info-page">
    <KTCodePreview v-bind:title="'Thông tin phiếu yêu cầu duyệt chi'">
      <template v-slot:preview>
        <approval-info-container
          :approval-id="approvalId"
          :initial-tab="initialTab"
          @save-success="handleSaveSuccess"
          @cancel="navigateToList"
          @tab-change="handleTabChange"
          ref="infoContainer"
        />
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import KTCodePreview from '@/view/content/CodePreview.vue';
import { approvalRouter } from '../router';

const ApprovalInfoContainer = () =>
  import(/* webpackPrefetch: true */ './components/ApprovalInfoContainer');

export default {
  name: 'ApprovalInfo',
  components: {
    KTCodePreview,
    ApprovalInfoContainer,
  },
  data() {
    return {
      approvalId: null,
      initialTab: 'information',
    };
  },
  created() {
    // Set breadcrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Phiếu yêu cầu duyệt chi', route: '/approval' },
      { title: 'Thông tin phiếu yêu cầu duyệt chi' },
    ]);

    // Get approval ID from route query
    if (this.$route.params.id) {
      this.approvalId = this.$route.params.id;
    }

    // Check for hash in route
    const hashName = this.$route.hash ? this.$route.hash.split('#')[1] : '';
    if (hashName === 'attach') {
      this.initialTab = 'attachments';
    }
  },
  methods: {
    /**
     * Handle successful save
     * @param {Object} data - Saved approval data
     */
    handleSaveSuccess() {
      this.navigateToList();
    },

    /**
     * Navigate to the approval list page
     */
    navigateToList() {
      this.$router.push({
        name: approvalRouter.list.name,
      });
    },

    /**
     * Handle tab change
     * @param {string} tabName - The name of the tab
     */
    handleTabChange(tabName) {
      // Update route hash based on tab
      if (tabName === 'attachments') {
        this.$router.replace({ hash: '#attach' });
      } else {
        this.$router.replace({ hash: '' });
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-4.scss';

.approval-info-page {
  // Additional styling if needed
}
</style>
